import { CircularProgress } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import { ConnectionStatus, ResourceStatus } from '../../../api/resources/useOcInsightsEvents';
import { StatusChipConfig } from './components/AnalysisStatus';

export function getStatusConfig(status: ResourceStatus | ConnectionStatus): StatusChipConfig {
  switch (status) {
    case 'not-started':
      return {
        icon: <HourglassEmptyOutlinedIcon fontSize='small' />,
        bgColor: 'info',
        color: 'text.secondary',
      };
    case 'connecting':
    case 'started':
      return {
        icon: <CircularProgress size='1.25rem' color='inherit' />,
        bgColor: 'warning.main',
      };
    case 'connected':
    case 'finished':
      return {
        icon: <CheckCircleOutlineIcon fontSize='small' />,
        bgColor: 'success.main',
      };
    case 'disconnected':
    case 'error':
      return {
        icon: <ErrorOutlineIcon fontSize='small' />,
        bgColor: 'error.main',
      };
    default:
      return {
        icon: <ErrorOutlineIcon fontSize='small' />,
        bgColor: 'info',
      };
  }
}

export function getInstructionText(
  connectionStatus: ConnectionStatus,
  recordingStatus: ResourceStatus,
  imageStatus: ResourceStatus,
  analysisStatus: ResourceStatus
): string | null {
  if (connectionStatus === 'connecting') return 'selfService.connectionStatus.connecting';
  if (connectionStatus === 'disconnected') return 'selfService.connectionStatus.disconnected';
  if (recordingStatus === 'not-started' || recordingStatus === 'started') return 'selfService.driveOverScaleInfo';
  if (imageStatus === 'started') return 'selfService.analysis.processing';
  if (analysisStatus === 'finished') return 'selfService.analysis.finished';
  return null;
}

export function getLowerStatus(status1: ResourceStatus, status2: ResourceStatus): ResourceStatus {
  const statusPriority: Record<ResourceStatus, number> = { 'not-started': 0, started: 1, finished: 2, error: 3 };
  return statusPriority[status1] <= statusPriority[status2] ? status1 : status2;
}

export function getEffectiveStatus(isFetched: boolean, status: ResourceStatus, gateOpen: boolean): ResourceStatus {
  return isFetched ? 'finished' : gateOpen ? status : 'not-started';
}
